import type { GlobConfig } from '#/config'

// 修改对应的
export const useGlobSetting = (): Readonly<GlobConfig> => {
  const env = import.meta.env.VITE_APP_ENV

  const apiUrlMap = {
    production: import.meta.env.VITE_GLOB_LOCAL_API_URL,
    dev: import.meta.env.VITE_GLOB_LOCAL_API_URL,
    acc: import.meta.env.VITE_GLOB_LOCAL_API_URL,
    mock: import.meta.env.VITE_GLOB_MOCK_API_URL
  }

  const isDevelopment = import.meta.env.VITE_APP_ENV === 'dev'
  const isAcc = import.meta.env.VITE_APP_ENV === 'acc'
  const isProd = import.meta.env.VITE_APP_ENV === 'production'

  const koneOnlineUrlDev = import.meta.env.VITE_KONE_ONLINE_API_URL_DEV
  const koneOnlineUrlQA = import.meta.env.VITE_KONE_ONLINE_API_URL_QA
  const koneOnlineUrlProd = import.meta.env.VITE_KONE_ONLINE_API_URL_PROD

  // 根据环境选择对应的 koneOnlineUrl
  const koneOnlineUrl = isDevelopment
    ? koneOnlineUrlDev
    : isAcc
      ? koneOnlineUrlQA
      : koneOnlineUrlProd

  const kedexOnlineUrlMap = {
    production: import.meta.env.VITE_KEDEX_ONLINE_PROD_API_URL,
    dev: import.meta.env.VITE_KEDEX_ONLINE_DEV_API_URL,
    acc: import.meta.env.VITE_KEDEX_ONLINE_QA_API_URL
  }

  const kedexOnlineUrl = kedexOnlineUrlMap[env]
  const apiUrl = apiUrlMap[env]

  // TODO: 对应的系统设置
  const res = {
    apiUrl,
    koneOnlineUrl,
    kedexOnlineUrl
  } as any

  return res
}
